.banner-container {
    margin: 8px 0;
}
